import { Outlet } from "react-router-dom";
import { AppSidebar } from "@/components/parcelio/app-sidebar";

export default function AppLayout() {
  return (
    <div className="flex min-h-dvh bg-background">
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>
  );
}
